// extracted by mini-css-extract-plugin
export var modal = "_bo-0";